import { Button, Container, Input, Link, Stack, Text, useToast } from "@chakra-ui/react";
import { useNavigate, Link as ReactLink, useSearchParams } from "react-router-dom";
import { useState, useEffect } from 'react';
import { POST } from "../../../utils/ApiRequestProvider";
import { useSelector } from "react-redux";

export default function ChangePassword() {
    const toast = useToast();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const user = useSelector((state: any) => state.user.value);

    const [formData, setFormData] = useState({
        password: '',
        confirmPassword: '',
        token: ''
    });
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        const vt = searchParams.get("vt");
        const expiry = new Date(searchParams.get("exp") ?? "2022-06-01");
        if (vt === undefined || expiry < new Date(Date.now())) {
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occured while proceeding your request!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
            navigate("/");
            return;
        }
        setFormData({ ...formData, token: vt ?? "" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (user?.role) navigate("/");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    async function onSubmit() {
        try {
            setLoading(true);
            const res = await POST(
                `/api/user/password/reset`,
                formData
            );

            toast({
                title: res.message,
                status: res.status,
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });

            if (res.status === 'success') {
                navigate('/login');
            }
            setLoading(false);
        } catch (err) {
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occured while proceeding your request!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
        }
    }

    return (
        <Container centerContent my={"auto"} py={32}>
            {
                <Stack spacing={3} w={'md'} boxShadow={'base'} p={6} rounded={'2xl'}>
                    <Text fontSize='2xl' color='textColor.headingColor' fontWeight={'bold'}>
                        Forgot your password?
                    </Text>
                    <Text mb={2} fontSize={'md'} color='textColor.supportingText' fontWeight={'normal'}>
                        You'll get an email with a reset link
                    </Text>
                    <Link color={'primary.400'} as={ReactLink} to={'/Login'}>
                        Back To Login?
                    </Link>
                    <Input
                        placeholder="New Password"
                        type={"password"}
                        size={"lg"}
                        p={13}
                        fontSize={"14px"}
                        fontWeight={"400"}
                        w={"full"}
                        value={formData.password}
                        onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                    />
                    <Input
                        placeholder="Confirm Password"
                        type={"password"}
                        size={"lg"}
                        p={13}
                        fontSize={"14px"}
                        fontWeight={"400"}
                        w={"full"}
                        value={formData.confirmPassword}
                        onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
                    />
                    <Button
                        bgGradient="linear(to-r, primary.100, primary.600)"
                        color="white"
                        rounded={"full"}
                        fontWeight={"400"}
                        fontSize={`sm`}
                        _hover={{ bgGradient: "linear(to-r, primary.100, primary.200)" }}
                        _active={{ bg: "linear(to-r, primary.500, primary.800)" }}
                        size={'md'}
                        w={"full"}
                        onClick={onSubmit}
                        isLoading={isLoading}
                    >
                        Change Password
                    </Button>
                </Stack>
            }
        </Container>
    )
}